import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateSalesArgument } from "../hooks";
import { SalesArgumentForm } from "../components";

export const CreateSalesArgument: React.FC = () => {
  const navigate = useNavigate();

  const { form, submit, loading } = useCreateSalesArgument({
    defaultValues: {},
    onCompleted: () => {
      toast.success("L'argumentaire a été créé avec succès");
      navigate("/sales-arguments");
    },
  });

  return (
    <>
      <Header
        title="Argumentaire"
        subtitle="Créer un nouvel argumentaire"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/sales-arguments`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvel argumentaire" />
          <SalesArgumentForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
